import React from "react";
import { Navbar, Container, Nav, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";
import HeaderLogo from "../../assets/logo (2).svg"
import {
  home_nav_content1,
  home_nav_content2,
  home_nav_content3,
  home_nav_content4,
} from "../../utility/constants";
import { news_subnav_content2, news_subnav_content1, news_subnav_content3, news_subnav_content4 } from "../../utility/constants";
import FBIcon from "../../assets/fb.svg";
import InstaIcon from "../../assets/insta.svg";
import LinkedInIcon from "../../assets/in.svg";
import NavDropdown from "react-bootstrap/NavDropdown";
import { NavLink } from 'react-router-dom';



function Header() {
  return (
    <header className="w-100">
      <Navbar sticky="top"
        expand="lg" 
        className=" row-rx-0 header-navbar"
      >
        <Container className="header-container bg-white" fluid>
          <Navbar.Brand className="col-md-4">
            <Image src={HeaderLogo} className="header-logo"
         
             alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="offcanvasNavbar" />
          <Navbar.Collapse id="offcanvasNavbar">
          <Nav className="d-flex justify-content-between list-inline flex-grow-1 nav-links col-md-2 custom-ml">


          <NavDropdown.Item as={NavLink} to="/office" activeClassName="active" className="text-decoration-none news-navbar-contents">
                Office
            </NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="/works" activeClassName="active" className="text-decoration-none news-navbar-contents">
                Works
            </NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="/news" activeClassName="active" className="text-decoration-none news-navbar-contents">
                News
            </NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="/contact" activeClassName="active" className="text-decoration-none news-navbar-contents">
                Contact
            </NavDropdown.Item>

{/* 
            <Nav.Link href="#Office" className="news-navbar-contents">
              {home_nav_content1}
            </Nav.Link>
         
          <Link to="/works" className="text-decoration-none">
            <Nav.Link href="#Works" className="news-navbar-contents" id="works-temp">
              {home_nav_content2}
            </Nav.Link>
          </Link>
          <Link to="/news" className="text-decoration-none">
            <Nav.Link href="#News" className="news-navbar-contents">
              {home_nav_content3}
            </Nav.Link>
          </Link>
          <Link to="/contact" className="text-decoration-none">
            <Nav.Link href="#Contact" className="news-navbar-contents">
              {home_nav_content4}
            </Nav.Link>
          </Link> */}
          </Nav>

          <div className="col-md-6 header-link">
            {/* <div className="d-flex work-listing-header p-0" > */}
            <div  className="header-icon-img">
              <img src={FBIcon} />
            </div>
            <div  className="header-icon-img">
              <img src={LinkedInIcon} />{" "}
            </div>
            <div className="header-icon-img">
              <img src={InstaIcon} />{" "}
            </div>
          </div>
          {/* </div> */}
          </Navbar.Collapse>
        </Container>
      </Navbar>


      <div>
    <div className="news-navbar d-flex justify-content-center">
    
      <Navbar sticky="top"   expand="md">
        <Container fluid  >
         
            <Nav>
              <Nav.Link href="#home" className="news-navlink-content">{news_subnav_content1}</Nav.Link>
              <Nav.Link href="#link" className="news-navlink-content">{news_subnav_content2}</Nav.Link>
              <Nav.Link href="#link" className="news-navlink-content">{news_subnav_content3}</Nav.Link>
              <Nav.Link href="#link" className="news-navlink-content">{news_subnav_content4}</Nav.Link>
            </Nav>
          
        </Container>
      </Navbar>
      
    </div>
    </div>
    </header>
  );
}

export default Header;
